import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";

export const DashboardPageSkeleton = () => (
  <div className="container mx-auto p-4 md:p-6 space-y-6 animate-fade-in">
    <Skeleton className="h-10 w-48" />
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {[1, 2, 3, 4].map((i) => (
        <Card key={i} className="p-6">
          <Skeleton className="h-4 w-24 mb-2" />
          <Skeleton className="h-8 w-16 mb-1" />
          <Skeleton className="h-3 w-32" />
        </Card>
      ))}
    </div>
    <div className="grid gap-4 md:grid-cols-2">
      <Card className="p-6">
        <Skeleton className="h-6 w-32 mb-4" />
        <Skeleton className="h-[300px] w-full" />
      </Card>
      <Card className="p-6">
        <Skeleton className="h-6 w-32 mb-4" />
        <Skeleton className="h-[300px] w-full" />
      </Card>
    </div>
  </div>
);

export const CalendarPageSkeleton = () => (
  <div className="container mx-auto p-4 md:p-6 animate-fade-in">
    <div className="flex justify-between items-center mb-6">
      <Skeleton className="h-10 w-48" />
      <Skeleton className="h-10 w-32" />
    </div>
    <Skeleton className="h-[600px] w-full rounded-lg" />
  </div>
);

export const CampaignsPageSkeleton = () => (
  <div className="container mx-auto p-4 md:p-6 space-y-6 animate-fade-in">
    <div className="flex justify-between items-center">
      <Skeleton className="h-10 w-48" />
      <Skeleton className="h-10 w-40" />
    </div>
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <Card key={i} className="p-6">
          <Skeleton className="h-6 w-3/4 mb-4" />
          <Skeleton className="h-4 w-full mb-2" />
          <Skeleton className="h-4 w-5/6 mb-4" />
          <div className="flex gap-2">
            <Skeleton className="h-6 w-16" />
            <Skeleton className="h-6 w-16" />
          </div>
        </Card>
      ))}
    </div>
  </div>
);

export const AnalyticsPageSkeleton = () => (
  <div className="container mx-auto p-4 md:p-6 space-y-6 animate-fade-in">
    <Skeleton className="h-10 w-48 mb-6" />
    <div className="grid gap-4 md:grid-cols-3">
      {[1, 2, 3].map((i) => (
        <Card key={i} className="p-6">
          <Skeleton className="h-4 w-24 mb-2" />
          <Skeleton className="h-8 w-20" />
        </Card>
      ))}
    </div>
    <Card className="p-6">
      <Skeleton className="h-6 w-40 mb-4" />
      <Skeleton className="h-[400px] w-full" />
    </Card>
  </div>
);

export const SettingsPageSkeleton = () => (
  <div className="container mx-auto p-4 md:p-6 space-y-6 animate-fade-in">
    <Skeleton className="h-10 w-48 mb-6" />
    {[1, 2, 3].map((i) => (
      <Card key={i} className="p-6">
        <Skeleton className="h-6 w-40 mb-4" />
        <div className="space-y-3">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
        </div>
      </Card>
    ))}
  </div>
);

export const GenericPageSkeleton = () => (
  <div className="container mx-auto p-4 md:p-6 space-y-6 animate-fade-in">
    <Skeleton className="h-10 w-48 mb-6" />
    <Card className="p-6">
      <Skeleton className="h-[400px] w-full" />
    </Card>
  </div>
);
